export enum TokenInputError {
  INSUFFICIENT_TOKEN_BALANCE = "INSUFFICIENT_TOKEN_BALANCE",
  INSUFFICIENT_TOKEN_INPUT = "INSUFFICIENT_TOKEN_INPUT",
  UNKNOWN = "UNKNOWN",
}
